import store from '../store';
import convert from 'xml-js'


export default class ExportConfig {
  constructor(api) {
    this.api = api
  }

  // listExportConfig
  list() {
    this.api.call_busy({
      '_class': 'ExportConfig',
      '_method': 'list',
    }).then(response => {
      let exportConfigurationItems = []
      response.export_config = response.export_config ? (response.export_config.length ? response.export_config : [response.export_config]) : []
      response.export_config.forEach(export_config => {
        exportConfigurationItems.push(export_config._attributes)
      })
// NOTE: TBD: add vSelect-specific properties
      exportConfigurationItems = exportConfigurationItems.map(a => ({ ...a, value: a.id, text: a.name }))
      exportConfigurationItems.sort((item1, item2) => {
        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1
      })
      store.commit('setExportConfigurationItems', exportConfigurationItems)
    })
  }

  // loadExportConfig
  load(id) {
    return this.api.call_busy({
      '_class': 'ExportConfig',
      '_method': 'load',
      'id': id
    }).then(response => {
      if (!response.export_config || !response.export_config.format || !response.export_config.format.column) {
        return
      }
      response.export_config.format.column = response.export_config.format.column.length ? response.export_config.format.column : [response.export_config.format.column]
      return response
    })
  }

  // createExportConfig
  create({id, name, jsonObject}) {
    const xml = this.buildXml(jsonObject)
    const params = {
      '_class': 'ExportConfig',
      'xml': xml,
      'name': name
    }
    if (id) {
      params.id = id
      params._method = 'update'
    } else {
      params._method = 'create'
    }
    if (name) {
      params.name = name
    }
console.log(xml)
    return this.api.call_busy(params).then(response => {
      // if (!response.export_config || !response.export_config.format || !response.export_config.format.column) {
      //   return
      // }
      // response.export_config.format.column = response.export_config.format.column.length ? response.export_config.format.column : [response.export_config.format.column]
      this.list()
      return response
    })
  }

  delete(id) {
    return this.api.call_busy({
      '_class': 'ExportConfig',
      '_method': 'delete',
      'id': id,
    }).then(response => {
      this.list()
      return response
    })
  }

  buildXml(jsonObject) {
    return convert.json2xml(jsonObject, {compact: true})
  }

  // fff() {
  //   xml: <format export_type="null" encoding="UTF-8" column_delimiter="semicolon" category_output="inline" inline_delimiter="comma">
  //     <column id="gender" header="Anrede" type="field"/>
  //     <column id="name" header="Nachname" type="field"/>
  //     </format>
  // }


  // NOTE: remove this method, it seems like exact copy of Folders:list() method
  // list() {
  //   return this.api.call_busy({
  //     '_class': 'ExportConfig',
  //     '_method': 'list',
  //   }).then(folders => {
  //     const foldersMap = {}

  //     // TODO: validation
  //     folders = folders.folder ?
  //       this._parseFolders(folders.folder, foldersMap)
  //       : []
  //     store.commit('setFolders', {folders, foldersMap: foldersMap})
  //   })
  // }

  // NOTE: remove this method, it is a copy from Folders
  // _parseFolders(folders, foldersMap) {
  //   let res = []
  //   if (!folders.length) {
  //     folders = [folders]
  //   }
  //   for (const i in folders) {
  //     let folder = folders[i]._attributes
  //     if (folders[i].folder) {
  //       folder.children = this._parseFolders(folders[i].folder, foldersMap)
  //     }
  //     res.push(folder)
  //     foldersMap[folder.id] = folder
  //   }
  //   return res
  // }
}
